/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSalesContractNoteService = {
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerSalesContractNote",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async save(mode, payload) {
    var url = "api/Save_CustomerSalesContractNote";

    if (mode == "create") {
      return await ApiService.post(url, payload);
    } else {
      return await ApiService.put(url, payload.RecordId, payload, "Guid");
    }
  },
  async delete(recordId) {
    var url = "api/Save_CustomerSalesContractNote";

    return await ApiService.delete(url, recordId, "Guid");
  },
  async getAttachments(recordId) {
    const requestScreenData = {
      url: "api/TransactionMediaMeta",
      filter: `TransactionRecordID eq ${recordId} and TransactionType eq 'CustomerSalesContractNote'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async saveAttachments(recordId, attachments) {
    var url = "api/TransactionMediaMeta";
    var payload = {
      TransactionRecordId: recordId,
      TransactionType: "CustomerSalesContractNote",
      TransactionMediaMetas: attachments.map((file) => ({
        TransactionRecordId: recordId,
        TransactionType: "CustomerSalesContractNote",
        RecordId: file.RecordId || "00000000-0000-0000-0000-000000000000",
        ContentType: file.ContentType,
        FileName: file.FileName,
        FileSize: file.FileSize,
        MediaBase64String: file.MediaBase64String || undefined,
      })),
    };

    return await ApiService.post(url, payload);
  },
};

export { CustomerSalesContractNoteService };
